export enum enumGlobalAlertType {
  Error = 0,
  Warning = 1,
  Information = 2,
}
